import { render, staticRenderFns } from "./calendar-item.vue?vue&type=template&id=412bf193&scoped=true&"
import script from "./calendar-item.vue?vue&type=script&lang=js&"
export * from "./calendar-item.vue?vue&type=script&lang=js&"
import style0 from "./calendar-item.vue?vue&type=style&index=0&id=412bf193&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412bf193",
  null
  
)

export default component.exports